import * as color from './colors'

const currentColorTheme = color

export default currentColorTheme
